/**
 * Ryan O'Dowd
 * 2023-05-02
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import globals from '@utils/globals';

const getStyles = ({fonts, globalScale, colors, bottomBorderColorOverride, windowWidth}) => {
  return {
    container: {
      display: 'flex',
      width: '100%',
      maxWidth: Math.min(globals.maxInnerWidth, windowWidth),
      flexGrow: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    innerContainer: {
      display: 'flex',
      width: '100%',
      maxWidth: Math.min(globals.maxInnerWidth, windowWidth),
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottomWidth: 4,
      borderBottomColor: bottomBorderColorOverride || colors.primaryLight,
    },
    referenceWrapper: {
      display: 'flex',
      flexGrow: 1,
      flexShrink: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 2,
      paddingLeft: 6,
    },
    referenceOnLineTwo: {
      flexDirection: 'column',
      alignItems: 'flex-end',
    },

    contextMenuReference: {
      display: 'flex',
      textAlign: 'center',
      color: colors.white,
    },
    menuOptions: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      marginLeft: 0,
      paddingLeft: 0,
    },
    contextMenuButton: {
      marginTop: 0,
      marginBottom: 2,
      marginRight: 2,
      marginLeft: 2,
    },
    offlineIcon: {
      position: 'absolute',
      color: colors.alert,
      fontSize: 22,
      top: 4,
      right: 8,
    },

    // @MARK: compare and add-to-goal dialogs
    compareInner: {
    },
    translationComparisonWrapper: {
      marginBottom: 8,
      padding: 8,
      paddingBottom: 0,
      backgroundColor: colors.primary,
      borderRadius: 12,
      borderColor: colors.primaryLight,
      borderWidth: 4,
    },
    translationWrapper: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: 8,
    },
    translationNameAndAbbreviation: {
      color: colors.white,
      fontSize: globalScale * 16,
      fontFamily: fonts.primaryBold,
    },
    translationName: {
      flexShrink: 1,
    },
    translationAbbreviation: {
      paddingLeft: 16,
      color: colors.primaryExtraLight,
    },
    compareVersesWrapperContainer: { // @TODO: common
      padding: 8,
      paddingLeft: 0,
    },
    foo: {
      flexShrink: 1,
    },
    badge: {
      position: 'absolute',
      top: 4,
      right: 8,
      backgroundColor: colors.gray,
      width: 12,
      height: 12,
      borderRadius: 6,
      borderWidth: 1,
      borderColor: colors.white,
    },
  };
};

export default getStyles;
